<div class="modal-content w-100 h-100 d-flex flex-column">
  <div class="section-title apm-text-red text-break d-flex align-items-center">
    <apm-fa-icon class="me-2" icon="warning" size="md"></apm-fa-icon>{{ resourceIds.title | apmTranslate }}
  </div>
  <hr class="gray-divider-1 mb-3" />
  <div class="mb-3">{{ resourceIds.blockingDescription | apmTranslate: [count()] }}</div>
  <div class="expiring-markup-table w-100 position-relative">
    <apm-table
      [getRowId]="getRowId"
      [showRemoveFilter]="false"
      [rowData]="rows()"
      [columnDefs]="columnDefs"
      [suppressRowTransform]="true"
      [autoGroupColumnDef]="autoGroupColumnDef"
      [headerHeight]="0"
      (action)="onTableAction($event)"
    ></apm-table>
  </div>
  <div class="d-flex flex-row justify-content-between mt-auto pt-3">
    <apm-button variant="secondary" (click)="deleteAll()" additionalClass="px-5">{{
      resourceIds.deleteAll | apmTranslate
    }}</apm-button>
    <div class="d-flex align-items-center gap-2">
      <apm-button variant="secondary" (click)="goToWpl()" additionalClass="px-5">{{
        resourceIds.goToWpl | apmTranslate
      }}</apm-button>
      <apm-button variant="primary" (click)="publishAll()" additionalClass="px-5">{{
        resourceIds.publishAll | apmTranslate
      }}</apm-button>
    </div>
  </div>
</div>
